import React, { useEffect } from 'react';
import { NavItem } from '../types';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/home/Hero';
import About from '../components/home/About';
import Platform from '../components/home/Platform';
import Services from '../components/home/Services';
import Team from '../components/home/Team';
import Contact from '../components/home/Contact';

const HomePage = () => {
  useEffect(() => {
    document.title = 'HandsForNeeds PVT LTD - Innovative Solutions';
    
    // Add meta description for SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'HandsForNeeds PVT LTD provides innovative platforms connecting service providers with customers, making everyday tasks simpler and more efficient.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'HandsForNeeds PVT LTD provides innovative platforms connecting service providers with customers, making everyday tasks simpler and more efficient.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);
  
  // Define navigation items
  const navItems: NavItem[] = [
    { title: 'Home', href: '/' },
    { title: 'About', href: '#about' },
    { title: 'Platform', href: '#platform' },
    { title: 'Services', href: '#services' },
    { title: 'Team', href: '#team' },
    { title: 'Contact', href: '#contact' }
  ];
  
  // Add CSS for fade-in animation
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .animate-fade-in {
        animation: fadeIn 1s ease forwards;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      <Navbar navItems={navItems} />
      <main>
        <Hero />
        <About />
        <Platform />
        <Services />
        <Team />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;